import { Route } from 'vue-router'
import { WebTrekkMouseEvent, WtsGtmWindow } from '@/webtrekk'

const wtsGtmWindow = window as unknown as WtsGtmWindow

export const updateTrackingInformation = (currentRoute: Route): void => {
  let webtrekkContentId = currentRoute.path.charAt(0) === '/' ? currentRoute.path.substr(1) : currentRoute.path

  // do not track pii data (contract id etc.)
  // TODO: params (phase 2) alle params mit Ids raus, evtl. generisch machen
  // e.g.: partnerAddressId/:policyId werden nicht getrackt bei path: '/vertraege/policen/:line/:partnerAddressId/:policyId',
  if (currentRoute.name === 'policen') {
    webtrekkContentId = webtrekkContentId.split('/').slice(0, 3).join('/')
  }

  // AUSKOMMENTIERT NUR FÜR TRACKING TEST AUF UAT
  // wtsGtmWindow._ti.contentId = `/meine-da-direkt/da/${webtrekkContentId}`;
  // wtsGtmWindow._ti.contentGroup = {
  //     1: 'kundenportal',
  //     2: contentGroup2
  // };
  //
  // wtsGtmWindow.wts.push(['send', 'pageupdate', true]);

  // push into GTM dataLayer
  wtsGtmWindow.dataLayer.push({
    contentId: webtrekkContentId,
    event: 'virtualPageView'
  })
  // simply logging enabled (window.name keeps alive as long as browser window)
  if (wtsGtmWindow.name === 'enableLog') {
    /* eslint-disable */
    console.log('track contentId (GTM): ', webtrekkContentId)
    console.log('track dataLayer (GTM): ', wtsGtmWindow.dataLayer)
    console.log('track contentGroups (WTS): ', wtsGtmWindow._ti.contentGroup)
    console.log('track contentId (WTS): ', wtsGtmWindow._ti.contentId)
    /* eslint-enable */
  }
}

export const trkClick = (e: WebTrekkMouseEvent): void => {
  const trackEl: HTMLElement | null = getElementByEvent(e)
  // trackEl:HTMLElement has dataset implemented; dataset.trackId must exist and must not be emptystring;
  if (
    trackEl !== null &&
    trackEl.dataset &&
    trackEl.dataset.trackId &&
    trackEl.dataset.trackId !== '' &&
    wtsGtmWindow._ti.contentGroup !== undefined
  ) {
    const trackId = trackEl.dataset.trackId
    // get current.page to linkId incl. contentgroup1
    const contentGroup1 = wtsGtmWindow._ti.contentGroup[1]
    const contentGroup2 = wtsGtmWindow._ti.contentGroup[2]
    // add mapped link id (trackIdsMap), or use directly attribute data-track-id
    const linkTrackId =
      wtsGtmWindow.trackIdsMap && wtsGtmWindow.trackIdsMap[trackId] ? wtsGtmWindow.trackIdsMap[trackId] : trackId
    // all together joined with ('.')
    const linkId = `${contentGroup1}.${contentGroup2}.${linkTrackId}`
    wtsGtmWindow.wts.push(['send', 'click', { linkId }])
    // simply logging enabled (window.name keeps alive as long as browser window)
    if (wtsGtmWindow.name === 'enableLog') {
      // eslint-disable-next-line
      console.log('track linkId (WTS): ', linkId)
    }
  }
}

// HTMLElement implements HTMLOrSVGElement (dataset is implemented)
const getElementByEvent = (e: WebTrekkMouseEvent): HTMLElement | null => {
  // this does not work if shadowDOM mode === closed
  const path: EventTarget[] = e.path || (e.composedPath && e.composedPath())
  // Show it if we got it
  if (path && path.length) {
    // do not move through all elements of path, links and buttons will probably not have more than e.g. 10 descendants...
    // increase size of path to run for if necessary
    // to get teaser links (policy teaser) tracked increase size of path from 5 to 10
    // let el: HTMLElement
    for (const el of path.slice(0, 10)) {
      if ((el as HTMLElement).dataset && (el as HTMLElement).dataset.trackId) {
        return el as HTMLElement
      }
    }
  }
  return null
}
